import { render, staticRenderFns } from "./PromotionsList.vue?vue&type=template&id=9876b1ee&scoped=true&"
import script from "./PromotionsList.vue?vue&type=script&lang=js&"
export * from "./PromotionsList.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsList.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./PromotionsList.vue?vue&type=style&index=1&id=9876b1ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9876b1ee",
  null
  
)

export default component.exports